export default __webpack_public_path__ + "static/media/Q1_4.5d053bf5.png";